import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Fabricante } from 'src/app/model/Fabricante';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FabricanteService {

  constructor(private http: HttpClient) { }

  findAll(): Observable<Fabricante[]> {
    return this.http.get<Fabricante[]>(`${environment.apiUrl}/view/fabricante`);
  }

  findById(id: number) {
    return this.http.get(`${environment.apiUrl}/view/fabricante/${id}`);
  }

  findByIdExample(id: number) { }

  save(fabricante: Fabricante) {
    if (fabricante.idfabricante !== undefined) {
      return this.http.put(`${environment.apiUrl}/view/fabricante`, fabricante);
    }

    return this.http.post(`${environment.apiUrl}/view/fabricante`, fabricante);
  }

  delete(id: number) {
    return this.http.delete(`${environment.apiUrl}/view/fabricante/${id}`);
  }
}
